import {AbstractViewTemplate} from "@mvvm/view/AbstractViewTemplate";
import {SingleTargetContainerFormatter} from "@mvvm/view/target_container_formatter/SingleTargetContainerFormatter";
import {NullPlatformDocument} from "@library/infrastracture/platform_document/NullPlatformDocument";
import {ENTRY_FIELDS, EntryInput} from "@library/domain/recruit/EntryField";

/**
 * 採用エントリーのフォーム（app/Views/recruit/entry/entry.twig）の View。
 *
 * - 入力値を読み取る
 * - エラーを #_entry_error_list に出す（<li> は <template id="_entry_error_item_template"> を複製して作る）
 */
export class EntryFormView extends AbstractViewTemplate {
    protected _viewName = "recruit_entry_form";

    readonly #form: HTMLFormElement;
    readonly #error_list: HTMLElement | null;
    readonly #error_item_template: HTMLTemplateElement | null;

    public constructor(doc: Document = document) {
        super(
            new NullPlatformDocument(),
            "",
            doc.getElementById("_entry_form"),
            new SingleTargetContainerFormatter()
        );
        this.#form = this._targetContainer as HTMLFormElement;
        this.#error_list = doc.getElementById("_entry_error_list");
        this.#error_item_template = doc.getElementById("_entry_error_item_template") as HTMLTemplateElement | null;
    }

    /**
     * @inheritDoc
     * フォームはサーバ側で描画済みのため、ここでは何もしない
     */
    protected render(DocumentForInsert: Document): void {}

    /**
     * フォームの入力値を読み取る
     */
    public readInput(): EntryInput {
        const form_data = new FormData(this.#form);
        const input = {} as EntryInput;
        for (const field of ENTRY_FIELDS) {
            const value = form_data.get(field);
            input[field] = typeof value === "string" ? value : "";
        }

        return input;
    }

    /**
     * 送信を購読する。handler が false を返したら送信を止める
     */
    public onSubmit(handler: () => boolean): void {
        this.#form.addEventListener("submit", (event: SubmitEvent) => {
            if (!handler()) {
                event.preventDefault();
            }
        });
    }

    /**
     * エラーを表示する（前のエラーは消す）
     */
    public showErrors(messages: readonly string[]): void {
        if (this.#error_list === null || this.#error_item_template === null) {
            return;
        }

        const items = messages.map((message) => {
            const item = this.#error_item_template!.content.firstElementChild!.cloneNode(true) as HTMLElement;
            item.textContent = message;
            return item;
        });
        this.#error_list.replaceChildren(...items);

        if (messages.length > 0) {
            this.#error_list.scrollIntoView({behavior: "smooth", block: "center"});
        }
    }
}
